import { useEffect, useState } from 'react';
import { getOfflineDownloadProgress, onOfflineDownloadProgress, OfflineDownloadProgress } from '../connector/offline/post-downloader';

// Live progress of the offline post download (see OfflinePostDownloader).
export function useOfflineDownloadProgress(): OfflineDownloadProgress {
  const [progress, setProgress] = useState(getOfflineDownloadProgress);
  useEffect(() => {
    setProgress(getOfflineDownloadProgress());
    return onOfflineDownloadProgress(setProgress);
  }, []);
  return progress;
}
